if (!customElements.get('mentions-filter-ttt')) {
  class MentionsFilterTtt extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-filter-country]'));
      this.items = Array.from(this.querySelectorAll('[data-mention-country]'));

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(button));
      });
    }

    select(activeButton) {
      const country = activeButton.dataset.filterCountry;

      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', button === activeButton ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        item.hidden = country !== '' && item.dataset.mentionCountry !== country;
      });
    }
  }

  customElements.define('mentions-filter-ttt', MentionsFilterTtt);
}
